/** The part of the vue-i18n composer the page's language lives in. */
export interface LocaleHolder {
  locale: { value: string }
}

/** True for anything shaped like the composer, which is all this needs. */
export function isLocaleHolder(value: unknown): value is LocaleHolder {
  if (typeof value !== 'object' || value === null) return false
  const locale: unknown = Reflect.get(value, 'locale')
  return (
    typeof locale === 'object' &&
    locale !== null &&
    typeof Reflect.get(locale, 'value') === 'string'
  )
}

/**
 * Points vue-i18n at the language the page is built for. Returns true when it
 * changed anything. An empty language leaves the composer alone, and a language
 * without messages still gets set: vue-i18n falls back to English for it, on
 * the server and in the browser alike, which is what keeps the two in step.
 */
export function applyLocale(
  i18n: LocaleHolder | undefined,
  language: string | undefined
): boolean {
  if (!i18n || !language) return false
  const next = language.toLowerCase()
  if (i18n.locale.value === next) return false
  i18n.locale.value = next
  return true
}

/** The language half of a group locale token, `fr-FR` gives `fr`. */
export function languageOf(locale: string | undefined): string | undefined {
  if (!locale) return undefined
  const language = locale.split('-')[0]?.toLowerCase()
  return language || undefined
}
